export default "__VITE_PUBLIC_ASSET__23d676c3__"